<template>
  <div>
    <van-nav-bar title="修改密码" left-text="返回" right-text="" @click-left="onClickLeft"/>
    <van-form @submit="updatepwd" class="login-form-top">
      <van-field
        v-model="oldpassword"
        type="password"
        name="旧密码"
        label="旧密码"
        placeholder="旧密码"
        :rules="[{ required: true, message: '请填写旧密码' }]"
      />
      <van-field
        v-model="password"
        type="password"
        name="新密码"
        label="新密码"
        placeholder="新密码"
        :rules="[{ required: true, message: '请填写新密码' }]"
      />
      <van-field
        v-model="secpassword"
        type="password"
        name="确认新密码"
        label="确认新密码"
        placeholder="确认新密码"
        :rules="[{ required: true, message: '请再次填写新密码' }]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="">确认修改</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>

import {Toast} from "vant";
import {isWechat} from "../../utils/util";

export default {
  name: "PasswordUpdate",
  data() {
    return {
      oldpassword: "",
      password: "",
      secpassword: ""
    };
  },
  mounted() {
    if(!isWechat()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
  },
  methods: {
    updatepwd: function () {
      if (this.password == this.secpassword) {
        this.$post("/api/blade-customer/register/updatePwd", {oldPwd: this.oldpassword, newPwd: this.password}).then(
          res => {
            const data = res.data;
            Toast.success('密码修改成功,请重新登录');
            this.$router.push({
              path: "/",
              query: {}
            });
            console.log("返回的数据：" + JSON.stringify(res));
          },
          error => {
          }
        );
      } else {
        Toast.fail('两次输入的密码不一致！');
      }

    },
    onClickLeft: function () {
      this.$router.push({
        path: "/attenceflow/UserInfo",
        query: {}
      });
    }
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

.login-form-top {
  margin-top: 0px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/PasswordUpdate.vue